import React from 'react'
import { LoginWrapper } from './login/LoginWrapper'
import { useTranslation } from 'react-i18next'

export const MaintenencePage = () => {
  const { t } = useTranslation()
  return (
    <LoginWrapper title="Wartungsarbeiten">
      <p>{t('pages.maintenencePage.info')}</p>
    </LoginWrapper>
  )
}
